import { ColorModeDataAttribute } from '../types';
export const setTheme = (theme) => {
    if (!theme) {
        return document.documentElement.removeAttribute(ColorModeDataAttribute);
    }
    return document.documentElement.setAttribute(ColorModeDataAttribute, theme);
};
/**
 * Get a css custom property var declaration for token
 *
 * @param tokenName name of token, delimited with dots
 * @returns css var declaration for token
 */
export const token = (tokenName) => {
    return `var(--tm-${tokenName.replace(/\./g, '-')})`;
};
